import React from 'react';
import PropTypes from 'prop-types';
var PageFooter = function PageFooter(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    sectiontype: "general",
    style: style
  }, children);
};
PageFooter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  className: PropTypes.object,
  style: PropTypes.object
};
PageFooter.defaultProps = {
  children: null,
  className: null,
  style: null
};
export default PageFooter;